import type { QueryClient } from "@tanstack/react-query";
import { keys } from "./keys";

/** Space-wide views listing pending quotes: the overview section and the pending sub-topic cards. */
export function invalidatePendingQuoteViews(queryClient: QueryClient, spaceId: string) {
  queryClient.invalidateQueries({ queryKey: keys.openQuotes(spaceId) });
  queryClient.invalidateQueries({ queryKey: keys.pendingSubTopics(spaceId) });
}
